/**
 * Handles close banners
 * @module closeBanner
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'closeBanner';

const closeBannerEventHandlers = () => {
  const closeBannerChild = $('.js-close-banner');
  const closeBannerParent = $('.js-close-parent');

  closeBannerChild.on('click', function() {
      closeBannerParent.hide();
  });
}

export default function bannerCloseBtn() {
  closeBannerEventHandlers();
}

registerJQueryPlugin(PLUGIN_NAME, bannerCloseBtn);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/close-banner.js